import React from 'react'
import { useState, useEffect } from 'react'
import Header from '../common/Header'
import SideMenu from '../common/SideMenu'

import './Rate.css'
import { useTranslation } from "react-i18next";

/**
 * v2 レート設定: ポイント↔元の単一レート（1pt = X 元）を設定する。
 * 仕様 §3.8（固定値運用・管理画面から手動更新）に対応。旧 default_shop_rates の
 * 国別 point→円 階層運用は撤廃。
 */
const Rate = () => {
  const { t } = useTranslation();

  const [rate, setRate] = useState('');
  const [updatedAt, setUpdatedAt] = useState(null);
  const [loading, setLoading] = useState(false);

  const getAuthHeaders = () => {
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) xsrfToken = xsrfToken.split('=')[1];
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) token = token.split('=')[1];
    return {
      'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
      'Bearer': decodeURIComponent(token),
      'Content-Type': 'application/json'
    };
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/shop-rate`, {
      headers: getAuthHeaders(), credentials: 'include', method: 'GET'
    })
      .then(r => r.json())
      .then(data => {
        if (data && data.rate != null) {
          setRate(String(data.rate));
          setUpdatedAt(data.updated_at || null);
        }
      })
      .catch(e => console.error(e));
  }, []);

  const saveRate = () => {
    const num = Number(rate);
    if (!num || num <= 0) {
      alert(t('rate.invalid'));
      return;
    }
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/shop-rate-edit`, {
      headers: getAuthHeaders(), credentials: 'include', method: 'POST',
      body: JSON.stringify({ rate: num })
    })
      .then(r => r.json())
      .then(data => {
        setLoading(false);
        if (data && data.rate != null) {
          setRate(String(data.rate));
          setUpdatedAt(data.updated_at || null);
          alert(t('rate.saved'));
        } else {
          alert((data && data.message) || t('common.error'));
        }
      })
      .catch(e => { setLoading(false); console.error(e); alert(t('common.error')); });
  };

  return (
    <>
      <Header />
      <SideMenu />
      <div className="rate">
        <div className="rate-title">{t('rate.title')}</div>
        <div className="clearfix"></div>

        <div className="rate-single">
          <span className="rate-single-label">1 pt =</span>
          <input
            className="rate-single-input"
            type="number"
            step="0.0001"
            min="0"
            value={rate}
            onChange={e => setRate(e.target.value)}
          />
          <span className="rate-single-unit">元</span>
        </div>

        <div className="rate-note">{t('rate.note')}</div>
        {updatedAt &&
          <div className="rate-updated">{t('rate.updated_at')}: {new Date(updatedAt).toLocaleString()}</div>
        }

        <div className="rate-button">
          <button className="rate-button-save" onClick={saveRate} disabled={loading}>{t('rate.save')}</button>
        </div>
      </div>
    </>
  )
}

export default Rate
